export default __webpack_public_path__ + "static/media/sEKwt.bbf51213.gif";